<template>
  <div>
    <h3 class="color-bold-vmain font-bold text-center text-lg">
        Đối tác tiêu biểu của Vclick
    </h3>
    <div class="mt-3 flex justify-evenly ">
        <!-- <img class="w-full" src="@/assets/default_main/4lg.png" > -->
        <img alt="shb image" class=" max-h-8" src="@/assets/default_main/shb_img.png" >
        <img alt="mirae image" class=" max-h-8" src="@/assets/default_main/logo_mira.png" >
        <img alt="mcredit image" class=" max-h-7" src="@/assets/default_main/mcredit.png" >
        <img alt="tima image" class=" max-h-8" src="@/assets/default_main/tima_img.png" > 
        
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>